import { render, staticRenderFns } from "./SupportConfirmation.vue?vue&type=template&id=3466c16a&scoped=true"
import script from "./SupportConfirmation.vue?vue&type=script&lang=js"
export * from "./SupportConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3466c16a",
  null
  
)

export default component.exports